"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.directionsCurrentLeg = exports.directionsFromGoogleMapsClientDirectionsResult = exports.directionsFromGoogleMapsDirectionsResponse = exports.directionsDeserialize = void 0;
const first_1 = __importDefault(require("lodash/first"));
const flatMap_1 = __importDefault(require("lodash/flatMap"));
const PolyUtil_1 = __importDefault(require("node-geometry-library/lib/PolyUtil"));
const element_1 = __importDefault(require("../util/element"));
const expect_1 = __importDefault(require("../util/expect"));
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const FirestoreTimestamp_1 = require("./firebase/FirestoreTimestamp");
const Trip_1 = require("./Trip");
function directionsDeserialize(value, firestore) {
    const object = (0, deserializeObject_1.default)(value, 'directions');
    const bounds = (0, deserializeObject_1.default)(object.bounds, 'bounds');
    const northeast = (0, deserializeObject_1.default)(bounds.northeast, 'northeast');
    const southwest = (0, deserializeObject_1.default)(bounds.southwest, 'southwest');
    return {
        bounds: {
            northeast: new firestore.GeoPoint(northeast._latitude, northeast._longitude),
            southwest: new firestore.GeoPoint(southwest._latitude, southwest._longitude),
        },
        creationTimestamp: (0, FirestoreTimestamp_1.firestoreTimestampDeserialize)(object.creationTimestamp),
        legs: (0, deserializeArray_1.default)(element => {
            const leg = (0, deserializeObject_1.default)(element);
            return {
                distanceM: (0, deserializeNumber_1.deserializeNumber)(leg.distanceM),
                durationS: (0, deserializeNumber_1.deserializeNumber)(leg.durationS),
                encodedPath: (0, deserializeString_1.deserializeString)(leg.encodedPath),
            };
        })(object.legs),
        tripId: (0, deserializeString_1.deserializeString)(object.tripId),
    };
}
exports.directionsDeserialize = directionsDeserialize;
function directionsFromGoogleMapsDirectionsResponse(response, tripId, firestore) {
    const route = (0, expect_1.default)((0, first_1.default)(response.routes), 'directions routes');
    return {
        bounds: {
            northeast: new firestore.GeoPoint(route.bounds.northeast.lat, route.bounds.northeast.lng),
            southwest: new firestore.GeoPoint(route.bounds.southwest.lat, route.bounds.southwest.lng),
        },
        creationTimestamp: firestore.serverTimestamp(),
        legs: route.legs.map(leg => {
            var _a, _b;
            const paths = (0, flatMap_1.default)(leg.steps.map(step => PolyUtil_1.default.decode(step.polyline.points)));
            const encodedPath = PolyUtil_1.default.encode(paths);
            return {
                distanceM: (0, expect_1.default)((_a = leg.distance) === null || _a === void 0 ? void 0 : _a.value),
                durationS: (0, expect_1.default)((_b = leg.duration) === null || _b === void 0 ? void 0 : _b.value),
                encodedPath,
            };
        }),
        tripId,
    };
}
exports.directionsFromGoogleMapsDirectionsResponse = directionsFromGoogleMapsDirectionsResponse;
function directionsFromGoogleMapsClientDirectionsResult(result, tripId, firestore) {
    const route = (0, expect_1.default)((0, first_1.default)(result.routes), 'directions routes');
    return {
        bounds: {
            northeast: new firestore.GeoPoint(route.bounds.getNorthEast().lat(), route.bounds.getNorthEast().lng()),
            southwest: new firestore.GeoPoint(route.bounds.getSouthWest().lat(), route.bounds.getSouthWest().lng()),
        },
        creationTimestamp: firestore.serverTimestamp(),
        legs: route.legs.map(leg => {
            var _a, _b;
            const paths = (0, flatMap_1.default)(leg.steps.map(step => step.path)).map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }));
            const encodedPath = PolyUtil_1.default.encode(paths);
            return {
                distanceM: (0, expect_1.default)((_a = leg.distance) === null || _a === void 0 ? void 0 : _a.value),
                durationS: (0, expect_1.default)((_b = leg.duration) === null || _b === void 0 ? void 0 : _b.value),
                encodedPath,
            };
        }),
        tripId,
    };
}
exports.directionsFromGoogleMapsClientDirectionsResult = directionsFromGoogleMapsClientDirectionsResult;
function directionsCurrentLeg(directions, trip) {
    // get current location
    const currentLocationIndex = (0, Trip_1.tripCurrentLocationWithDefault)(trip);
    // trip is inactive
    if (currentLocationIndex === undefined) {
        return undefined;
    }
    // if driver leg is present
    if (trip.locations && directions.legs.length === trip.locations.length) {
        // return leg with current location index
        return (0, element_1.default)(directions.legs, currentLocationIndex);
    }
    else {
        // return index minus one
        return (0, element_1.default)(directions.legs, currentLocationIndex - 1);
    }
}
exports.directionsCurrentLeg = directionsCurrentLeg;
